export class LeadType {
    constructor(
        public id: number,
        public name: string
    ){}
}
